/*
  Fish Harbor — графік доставок.
  Спільна логіка для блоку з рибаком (sections/delivery-catch.liquid)
  і для рядка «Наступна доставка» у смузі оголошень.

  Дати приходять з таблиці «Доставки» (метаоб'єкт fh_delivery) через
  snippets/fh-delivery-data.liquid. Фазу (прийом / доставка / невідомо)
  рахуємо тут, у браузері, бо Shopify кешує готові сторінки: сервер може
  віддати копію, зроблену до дедлайну.
*/
(function () {
  if (window.FHDelivery) return;

  var TZ = 'Europe/Prague';
  var DAY = 864e5;

  var STRINGS = {
    uk: {
      pill_next: 'Наступна доставка',
      pill_now: 'Зараз доставляємо',
      open_before: 'Замовте до ',
      open_after: ' — і рибка встигне на цю доставку.',
      deliv_before: 'Рибак розвозить замовлення. Нові замовлення вже приймаємо — вони поїдуть з доставкою ',
      deliv_after: '.',
      deliv_none: 'Рибак розвозить замовлення. Дату наступної доставки уточнюємо.',
      deliv_sub: 'Прийом на неї відкритий до {deadline}.',
      unknown: 'Дату наступної доставки уточнюємо.',
      cta_open: 'Встигнути замовити',
      cta_next: 'Замовити на наступну доставку',
      u_d: 'ДНІВ', u_h: 'ГОД', u_m: 'ХВ', u_s: 'СЕК',
      tag_days: 'ще {n} {days}',
      tag_hours: 'останні години!',
      days: ['день', 'дні', 'днів'],
      ruler_start: 'Ловимо вашу рибку →',
      ruler_deadline: 'Улов!',
      wk_gen: ['понеділка', 'вівторка', 'середи', 'четверга', 'пʼятниці', 'суботи', 'неділі'],
      wk_short: ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'нд'],
      bar_open: 'Наступна доставка {range} · замовлення до {wd} {time}',
      bar_now: 'Зараз доставляємо · нові замовлення — на {next}',
      bar_now_nonext: 'Зараз доставляємо · дату наступної доставки уточнюємо',
      bar_unknown: 'Дату наступної доставки уточнюємо',
      scene_open: 'Рибак підтягує рибку: до кінця прийому замовлень {n} {days}',
      scene_now: 'Рибак поїхав доставляти замовлення',
      timer_label: 'Час до кінця прийому замовлень',
      sign1: 'ПОЇХАВ', sign2: 'ДОСТАВЛЯТИ',
      plural: 'uk'
    },
    cs: {
      pill_next: 'Příští doručení',
      pill_now: 'Právě doručujeme',
      open_before: 'Objednejte do ',
      open_after: ' — a rybka stihne toto doručení.',
      deliv_before: 'Rybář rozváží objednávky. Nové objednávky už přijímáme — pojedou s doručením ',
      deliv_after: '.',
      deliv_none: 'Rybář rozváží objednávky. Termín dalšího doručení upřesníme.',
      deliv_sub: 'Objednávky na něj přijímáme do {deadline}.',
      unknown: 'Termín dalšího doručení upřesníme.',
      cta_open: 'Stihnout objednat',
      cta_next: 'Objednat na další doručení',
      u_d: 'DNÍ', u_h: 'HOD', u_m: 'MIN', u_s: 'SEK',
      tag_days: 'ještě {n} {days}',
      tag_hours: 'poslední hodiny!',
      days: ['den', 'dny', 'dní'],
      ruler_start: 'Chytáme vaši rybku →',
      ruler_deadline: 'Úlovek!',
      wk_gen: ['pondělí', 'úterý', 'středy', 'čtvrtka', 'pátku', 'soboty', 'neděle'],
      wk_short: ['po', 'út', 'st', 'čt', 'pá', 'so', 'ne'],
      bar_open: 'Příští doručení {range} · objednávky do {wd} {time}',
      bar_now: 'Právě doručujeme · nové objednávky — na {next}',
      bar_now_nonext: 'Právě doručujeme · termín dalšího doručení upřesníme',
      bar_unknown: 'Termín dalšího doručení upřesníme',
      scene_open: 'Rybář přitahuje rybku: do uzávěrky zbývá {n} {days}',
      scene_now: 'Rybář odjel rozvážet objednávky',
      timer_label: 'Čas do uzávěrky objednávek',
      sign1: 'ODJEL', sign2: 'ROZVÁŽET',
      plural: 'cs'
    },
    vi: {
      pill_next: 'Đợt giao tiếp theo',
      pill_now: 'Đang giao hàng',
      open_before: 'Đặt hàng trước ',
      open_after: ' để kịp đợt giao này.',
      deliv_before: 'Người câu cá đang đi giao hàng. Chúng tôi vẫn nhận đơn mới — đơn sẽ được giao vào đợt ',
      deliv_after: '.',
      deliv_none: 'Người câu cá đang đi giao hàng. Ngày giao tiếp theo sẽ được thông báo sớm.',
      deliv_sub: 'Nhận đơn cho đợt này đến {deadline}.',
      unknown: 'Ngày giao tiếp theo sẽ được thông báo sớm.',
      cta_open: 'Đặt hàng ngay',
      cta_next: 'Đặt cho đợt giao tiếp theo',
      u_d: 'NGÀY', u_h: 'GIỜ', u_m: 'PHÚT', u_s: 'GIÂY',
      tag_days: 'còn {n} {days}',
      tag_hours: 'những giờ cuối!',
      days: ['ngày', 'ngày', 'ngày'],
      ruler_start: 'Đang câu cá cho bạn →',
      ruler_deadline: 'Mẻ cá!',
      wk_gen: ['Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy', 'Chủ Nhật'],
      wk_short: ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'],
      bar_open: 'Đợt giao tiếp theo {range} · đặt trước {wd} {time}',
      bar_now: 'Đang giao hàng · đơn mới — đợt {next}',
      bar_now_nonext: 'Đang giao hàng · ngày giao tiếp theo sẽ được thông báo',
      bar_unknown: 'Ngày giao tiếp theo sẽ được thông báo sớm',
      scene_open: 'Người câu cá đang kéo cá: còn {n} {days} để đặt hàng',
      scene_now: 'Người câu cá đang đi giao hàng',
      timer_label: 'Thời gian còn lại để đặt hàng',
      sign1: 'ĐI', sign2: 'GIAO HÀNG',
      plural: 'none'
    }
  };

  function strings(locale) {
    var key = String(locale || '').toLowerCase().slice(0, 2);
    return STRINGS[key] || STRINGS.uk;
  }

  function fill(tpl, vars) {
    return String(tpl).replace(/\{(\w+)\}/g, function (m, k) {
      return vars[k] !== undefined ? vars[k] : m;
    });
  }

  function daysWord(s, n) {
    var f = s.days;
    if (s.plural === 'none') return f[0];
    if (s.plural === 'cs') {
      if (n === 1) return f[0];
      if (n >= 2 && n <= 4) return f[1];
      return f[2];
    }
    var m10 = n % 10, m100 = n % 100;
    if (m10 === 1 && m100 !== 11) return f[0];
    if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return f[1];
    return f[2];
  }

  // Різниця між празьким «настінним» часом і UTC у мілісекундах для моменту ms.
  // Потрібна, щоб перехід на літній/зимовий час не зсував кінець дня доставки.
  function pragueOffset(ms) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: TZ, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      }).formatToParts(new Date(ms));
      var g = function (t) {
        for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return Number(parts[i].value);
        return 0;
      };
      var asUtc = Date.UTC(g('year'), g('month') - 1, g('day'), g('hour') % 24, g('minute'), g('second'));
      return asUtc - Math.floor(ms / 1000) * 1000;
    } catch (e) {
      return 0;
    }
  }

  function pragueWallToMs(y, mo, d, h, mi, sec) {
    var guess = Date.UTC(y, mo - 1, d, h, mi, sec);
    var t = guess - pragueOffset(guess);
    return guess - pragueOffset(t);
  }

  function parseYmd(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s || ''));
    if (!m) return null;
    return { y: Number(m[1]), m: Number(m[2]), d: Number(m[3]) };
  }

  function dm(ymd) {
    return (ymd.d < 10 ? '0' : '') + ymd.d + '/' + (ymd.m < 10 ? '0' : '') + ymd.m;
  }

  function pragueParts(ms) {
    var off = pragueOffset(ms);
    var w = new Date(ms + off);
    return {
      d: w.getUTCDate(), m: w.getUTCMonth() + 1,
      hh: w.getUTCHours(), mm: w.getUTCMinutes(),
      wd: (w.getUTCDay() + 6) % 7
    };
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function parse(raw) {
    var list;
    try { list = JSON.parse(raw || '[]'); } catch (e) { list = []; }
    if (!Array.isArray(list)) return [];
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var it = list[i] || {};
      var deadline = Number(it.deadline);
      var s = parseYmd(it.start), e = parseYmd(it.end);
      if (!isFinite(deadline) || deadline <= 0 || !s || !e) continue;
      var startMs = pragueWallToMs(s.y, s.m, s.d, 0, 0, 0);
      var endMs = pragueWallToMs(e.y, e.m, e.d, 23, 59, 59);
      // Рядок з кінцем доставки раніше за дедлайн — помилка введення; пропускаємо.
      if (endMs < deadline || endMs < startMs) continue;
      out.push({ deadline: deadline, startMs: startMs, endMs: endMs, s: s, e: e });
    }
    out.sort(function (a, b) { return a.deadline - b.deadline; });
    return out;
  }

  function state(entries, now) {
    for (var i = 0; i < entries.length; i++) {
      var cur = entries[i];
      if (now > cur.endMs) continue;
      var prev = i > 0 ? entries[i - 1] : null;
      var next = i + 1 < entries.length ? entries[i + 1] : null;
      if (now < cur.deadline) {
        var winStart = prev && prev.endMs < cur.deadline ? prev.endMs : cur.deadline - 10 * DAY;
        return { phase: 'open', cur: cur, next: next, winStart: winStart };
      }
      return { phase: 'delivering', cur: cur, next: next };
    }
    return { phase: 'unknown' };
  }

  function range(entry) {
    var a = dm(entry.s), b = dm(entry.e);
    return a === b ? a : a + ' – ' + b;
  }

  function deadlineLong(s, ms) {
    var p = pragueParts(ms);
    return s.wk_gen[p.wd] + ' ' + pad(p.d) + '/' + pad(p.m) + ', ' + pad(p.hh) + ':' + pad(p.mm);
  }

  function deadlineShort(s, ms) {
    var p = pragueParts(ms);
    return { wd: s.wk_short[p.wd], time: pad(p.hh) + ':' + pad(p.mm) };
  }

  function barText(s, st) {
    if (st.phase === 'open') {
      var ds = deadlineShort(s, st.cur.deadline);
      return fill(s.bar_open, { range: range(st.cur), wd: ds.wd, time: ds.time });
    }
    if (st.phase === 'delivering') {
      return st.next ? fill(s.bar_now, { next: range(st.next) }) : s.bar_now_nonext;
    }
    return s.bar_unknown;
  }

  window.FHDelivery = {
    DAY: DAY,
    strings: strings,
    fill: fill,
    daysWord: daysWord,
    parse: parse,
    state: state,
    range: range,
    deadlineLong: deadlineLong,
    barText: barText,
    pad: pad
  };

  /* Рядок у смузі оголошень. */
  if (!customElements.get('fh-delivery-text')) {
    customElements.define('fh-delivery-text', class extends HTMLElement {
      connectedCallback() {
        var data = this.querySelector('script[data-fh-delivery-data]');
        this.entries = parse(data ? data.textContent : '[]');
        this.s = strings(this.dataset.locale);
        this.out = this.querySelector('[data-fh-text]');
        this.render();
        var self = this;
        this.timer = setInterval(function () { self.render(); }, 30000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      render() {
        if (!this.out) return;
        this.out.textContent = barText(this.s, state(this.entries, Date.now()));
      }
    });
  }

  /* Блок з рибаком. */
  if (!customElements.get('fh-delivery-catch')) {
    customElements.define('fh-delivery-catch', class extends HTMLElement {
      connectedCallback() {
        var data = this.querySelector('script[data-fh-delivery-data]');
        this.entries = parse(data ? data.textContent : '[]');
        this.s = strings(this.dataset.locale);
        this.q = {};
        var nodes = this.querySelectorAll('[data-fh]');
        for (var i = 0; i < nodes.length; i++) this.q[nodes[i].getAttribute('data-fh')] = nodes[i];
        if (!this.q.ruler && this.q['ruler-start']) this.q.ruler = this.q['ruler-start'].parentNode;
        this.progress = 0;
        this.phase = '';
        this.applyStaticText();
        this.tick();
        var self = this;
        this.timer = setInterval(function () { self.tick(); }, 1000);

        this.still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.visible = true;
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (es) {
            self.visible = es[0] && es[0].isIntersecting;
            if (self.visible) self.startAnim();
          });
          this.io.observe(this);
        }
        this.drawFrame(0);
        this.startAnim();
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = null;
        if (this.io) this.io.disconnect();
      }

      setText(key, value) {
        if (this.q[key]) this.q[key].textContent = value;
      }

      show(key, on) {
        var el = this.q[key];
        if (!el) return;
        if (el instanceof SVGElement) el.setAttribute('display', on ? 'inline' : 'none');
        else el.hidden = !on;
      }

      applyStaticText() {
        var s = this.s;
        this.setText('u-d', s.u_d);
        this.setText('u-h', s.u_h);
        this.setText('u-m', s.u_m);
        this.setText('u-s', s.u_s);
        this.setText('sign1', s.sign1);
        this.setText('sign2', s.sign2);
        this.setText('ruler-start', s.ruler_start);
        this.setText('ruler-deadline', s.ruler_deadline);
        this.setText('open-before', s.open_before);
        this.setText('open-after', s.open_after);
        this.setText('deliv-before', s.deliv_before);
        this.setText('deliv-after', s.deliv_after);
        if (this.q.timer) this.q.timer.setAttribute('aria-label', s.timer_label);
      }

      tick() {
        var s = this.s, now = Date.now();
        var st = state(this.entries, now);
        var open = st.phase === 'open', deliv = st.phase === 'delivering';

        this.setText('pill', deliv ? s.pill_now : s.pill_next);
        this.setText('date', st.cur ? range(st.cur) : '');
        this.show('date', !!st.cur);
        this.show('ruler', open);
        this.show('open-text', open);
        this.show('deliv-text', deliv);
        this.show('unknown-text', st.phase === 'unknown');
        this.setText('unknown-text', s.unknown);
        this.show('timer', open);
        this.setText('cta-text', deliv ? s.cta_next : s.cta_open);

        this.show('fisher', !deliv);
        this.show('line', open);
        this.show('ripple', open);
        this.show('fish', open);
        this.show('tag', open);
        this.show('sign', deliv);

        if (open) {
          this.setText('open-deadline', deadlineLong(s, st.cur.deadline));
          var left = Math.max(0, st.cur.deadline - now);
          var span = Math.max(DAY, st.cur.deadline - st.winStart);
          this.progress = Math.min(1, Math.max(0, 1 - left / span));
          var sec = Math.floor(left / 1000);
          var d = Math.floor(sec / 86400), h = Math.floor((sec % 86400) / 3600);
          var m = Math.floor((sec % 3600) / 60), ss = sec % 60;
          this.setText('d', String(d));
          this.setText('h', pad(h));
          this.setText('m', pad(m));
          this.setText('s', pad(ss));
          this.setText('tag', d > 0 ? fill(s.tag_days, { n: d, days: daysWord(s, d) }) : s.tag_hours);
          if (this.q.scene) this.q.scene.setAttribute('aria-label', fill(s.scene_open, { n: d, days: daysWord(s, d) }));
        } else {
          this.progress = 0;
          if (deliv) {
            this.setText('deliv-before', st.next ? s.deliv_before : s.deliv_none);
            this.setText('deliv-next', st.next ? range(st.next) : '');
            this.setText('deliv-after', st.next ? s.deliv_after : '');
            this.show('deliv-sub', !!st.next);
            if (st.next) this.setText('deliv-sub', fill(s.deliv_sub, { deadline: deadlineLong(s, st.next.deadline) }));
            if (this.q.scene) this.q.scene.setAttribute('aria-label', s.scene_now);
          }
        }
        if (this.phase !== st.phase) {
          this.phase = st.phase;
          this.drawFrame(this.lastClock || 0);
        }
      }

      startAnim() {
        if (this.still || this.raf) return;
        var self = this, last = 0;
        var step = function (ts) {
          if (!self.visible || !self.isConnected) { self.raf = null; return; }
          if (ts - last > 33) { last = ts; self.drawFrame(ts); }
          self.raf = requestAnimationFrame(step);
        };
        this.raf = requestAnimationFrame(step);
      }

      // Рибка, вудка й волосінь рахуються від одного годинника, тому волосінь
      // завжди з'єднує кінчик вудки з ротом рибки.
      drawFrame(clock) {
        this.lastClock = clock;
        var q = this.q;
        var ease = function (x) { return 0.5 - 0.5 * Math.cos(Math.PI * x); };
        var ph = (clock / 2600) % 1;
        var k = ph < 0.45 ? ease(ph / 0.45) : (ph < 0.6 ? 1 : 1 - ease((ph - 0.6) / 0.4));
        var tug = k * 9, pullDeg = k * 2.5;
        var wiggle = 6 * Math.sin((2 * Math.PI * clock) / 1600);
        var bob = 3 * Math.sin((2 * Math.PI * clock) / 1600 + 1);

        var mouthBase = 70 + this.progress * 770;
        var fx = mouthBase - 50 + tug, fy = 186 + bob;
        var wr = wiggle * Math.PI / 180;
        var mx = fx + 24 + 26 * Math.cos(wr), my = fy + 26 * Math.sin(wr);
        var pr = pullDeg * Math.PI / 180;
        var rx = 944 - 144 * Math.cos(pr) + 50 * Math.sin(pr);
        var ry = 66 - 144 * Math.sin(pr) - 50 * Math.cos(pr);
        var cx = (rx + mx) / 2, cy = 62;

        var r1 = function (n) { return Math.round(n * 10) / 10; };
        if (q.pull) q.pull.setAttribute('transform', 'rotate(' + r1(pullDeg) + ' 944 66)');
        if (q.fish) q.fish.setAttribute('transform', 'translate(' + r1(fx) + ' ' + r1(fy) + ')');
        if (q.fishrot) q.fishrot.setAttribute('transform', 'rotate(' + r1(wiggle) + ' 24 0)');
        if (q.line) q.line.setAttribute('d', 'M' + r1(rx) + ' ' + r1(ry) + ' Q' + r1(cx) + ' ' + cy + ' ' + r1(mx) + ' ' + r1(my));
        if (q.tag) q.tag.setAttribute('x', String(Math.max(60, Math.min(800, Math.round(mouthBase - 26)))));
        if (q.ripple) {
          var ripX = mx;
          for (var i = 0; i <= 100; i++) {
            var t = i / 100;
            var y = (1 - t) * (1 - t) * ry + 2 * (1 - t) * t * cy + t * t * my;
            if (y >= 96) { ripX = (1 - t) * (1 - t) * rx + 2 * (1 - t) * t * cx + t * t * mx; break; }
          }
          q.ripple.setAttribute('transform', 'translate(' + Math.round(ripX) + ' 97)');
        }
      }
    });
  }
})();
